import { Col, Container, Row } from "reactstrap";

const Description = () => {
  return (

          <Col lg={12} className="section" id="description">
            <div className="text-center w-75 mx-auto">
              <p className="user-review">
                <span className="fw-bold"> Northern Lights College (NLC)</span> ,
                yang berlokasi di British Columbia Utara, Kanada, adalah 
                institusi pendidikan tinggi terkemuka yang menawarkan 
                pendidikan praktis dan terapan di berbagai program. Dengan lebih dari 
                100 program dan 580+ mata kuliah, NLC menyediakan studi di bidang-bidang 
                seperti Bisnis, Kesehatan dan Layanan Sosial, serta Pendidikan
                yang dirancang untuk membekali mahasiswa dengan keterampilan yang 
                dibutuhkan di dunia kerja. 
              </p>
            </div>
          </Col>

  );
};

export default Description;